import { useEffect } from "react";

import { PrimeReactProvider } from "primereact/api";

import AppRouter from "./AppRouter";
import { UserContextProvider } from "./contexts/UserContext";

// Import needed styles
import "primereact/resources/primereact.min.css"; // Core CSS
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";

function App() {
  useEffect(() => {
    document.body.className = "light-mode";
    document.documentElement.setAttribute("data-theme", "light");
  }, []);

  return (
    <PrimeReactProvider>
      <UserContextProvider>
        <AppRouter />
      </UserContextProvider>
    </PrimeReactProvider>
  );
}

export default App;
